import {
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisNL,
  flowIdRiskAnalysisShortBE,
  flowIdSalesConversation,
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
  flowIdDeMotoVerzekering,
  flowIdVillasureOfferFlow,
  flowIdVillasureContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdPiaBoatContractFlow,
  flowIdBikmoOfferFlow,
  flowIdBikmoContractFlow,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdShortCheckupCompanyNL,
  flowIdShortCheckupCustomerNL,
  flowIdCfVerzekeringen,
  flowIdAskaTravelOffer,
  flowIdAskaTravelContract,
  flowIdShortCheckupCompanyBE,
  flowIdShortCheckupCustomerBE,
  flowIdGoudseCompanyScan,
  flowIdLoonzorgNederlandFlowId,
} from '../constants/flowIds';
import AdvisoryFlowView from '../components/ui/advisory-flow/components/AdvisoryFlowView';
import AdvisoryFlowError from '../components/ui/advisory-flow/components/app-shell/AdvisoryFlowError';
import AdvisoryFlowLoading from '../components/ui/advisory-flow/components/app-shell/AdvisoryFlowLoading';
import AdvisoryAppShell from '../components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import CompanyScanAppShell from '../components/ui/company-scan/components/app-shell/CompanyScanAppShell';
import CompanyScanError from '../components/ui/company-scan/components/app-shell/CompanyScanError';
import CompanyScanLoading from '../components/ui/company-scan/components/app-shell/CompanyScanLoading';
import CompanyScanView from '../components/ui/company-scan/components/CompanyScanView';
import { FlowConfig, FlowType } from '../types/ConfigTypes';

const advisoryFlowUIConfig = {
  appShell: AdvisoryAppShell,
  loadingView: AdvisoryFlowLoading,
  errorView: AdvisoryFlowError,
  visualEnvironment: AdvisoryFlowView,
};

const companyScanFlowUIConfig = {
  appShell: CompanyScanAppShell,
  loadingView: CompanyScanLoading,
  errorView: CompanyScanError,
  visualEnvironment: CompanyScanView,
  title: 'COMPANY-SCAN',
  src: '/company-scan',
  flowType: FlowType.COMPANY_SCAN,
};

const flowsConfig: FlowConfig = {
  [flowIdRiskAnalysisNL]: {
    ...advisoryFlowUIConfig,
    title: 'RISK-ANALYSIS',
    src: '/risk-analysis',
    flowType: FlowType.RISK_ANALYSIS,
  },
  [flowIdRiskAnalysisBE]: {
    ...advisoryFlowUIConfig,
    title: 'RISK-ANALYSIS',
    src: '/risk-analysis',
    flowType: FlowType.RISK_ANALYSIS,
  },
  [flowIdRiskAnalysisShortBE]: {
    ...advisoryFlowUIConfig,
    title: 'RISK-ANALYSIS',
    src: '/risk-analysis',
    flowType: FlowType.RISK_ANALYSIS,
  },
  [flowIdSalesConversation]: {
    ...advisoryFlowUIConfig,
    title: 'Advisory conversation',
    src: '/product/session',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdCompanyScanBE]: companyScanFlowUIConfig,
  [flowIdCompanyScanNL]: companyScanFlowUIConfig,
  [flowIdGoudseCompanyScan]: companyScanFlowUIConfig,
  [flowIdDeMotoVerzekering]: {
    ...advisoryFlowUIConfig,
    title: 'Advisory conversation',
    src: '/product/session',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdVillasureOfferFlow]: {
    ...advisoryFlowUIConfig,
    title: 'Villasure',
    src: '/sales-conversation/villasure/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdShortCheckupCompanyNL]: {
    ...advisoryFlowUIConfig,
    title: 'Company checkup',
    src: '/sales-conversation/company-checkup',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdShortCheckupCustomerNL]: {
    ...advisoryFlowUIConfig,
    title: 'Customer checkup',
    src: '/sales-conversation/customer-checkup',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdShortCheckupCompanyBE]: {
    ...advisoryFlowUIConfig,
    title: 'Company checkup',
    src: '/sales-conversation/company-checkup',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdShortCheckupCustomerBE]: {
    ...advisoryFlowUIConfig,
    title: 'Customer checkup',
    src: '/sales-conversation/customer-checkup',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdCfVerzekeringen]: {
    ...advisoryFlowUIConfig,
    title: 'CF Verzekeringen',
    src: '/sales-conversation/cf-verzekeringen',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdAskaTravelOffer]: {
    ...advisoryFlowUIConfig,
    title: 'Aska travel',
    src: '/sales-conversation/aska-travel/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdAskaTravelContract]: {
    ...advisoryFlowUIConfig,
    title: 'Aska travel',
    src: '/sales-conversation/aska-travel/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdVillasureContractFlow]: {
    ...advisoryFlowUIConfig,
    title: 'Villasure',
    src: '/product/session',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdPiaBoatOfferFlow]: {
    ...advisoryFlowUIConfig,
    title: 'Boat',
    src: '/sales-conversation/boat/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdPiaBoatContractFlow]: {
    ...advisoryFlowUIConfig,
    title: 'BOAT',
    src: '/sales-conversation/boat/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdBikmoOfferFlow]: {
    ...advisoryFlowUIConfig,
    title: 'Bikmo',
    src: '/sales-conversation/bikmo/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdBikmoContractFlow]: {
    ...advisoryFlowUIConfig,
    title: 'Bikmo',
    src: '/sales-conversation/bikmo/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdCyclingVlaanderenContractFlowId]: {
    ...advisoryFlowUIConfig,
    title: 'Cycling vlaanderen',
    src: '/sales-conversation/cycling-vlaanderen/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdCyclingVlaanderenOfferFlowId]: {
    ...advisoryFlowUIConfig,
    title: 'Cycling vlaanderen',
    src: '/sales-conversation/cycling-vlaanderen/offers',
    flowType: FlowType.SALES_CONVERSATION,
  },
  [flowIdLoonzorgNederlandFlowId]: {
    ...advisoryFlowUIConfig,
    title: 'Loonzorg',
    src: `/sales-conversation/default/${flowIdLoonzorgNederlandFlowId}`,
    flowType: FlowType.SALES_CONVERSATION,
  },
};

export const defaultFlowsConfig = (flowId: string) => ({
  ...advisoryFlowUIConfig,
  title: 'Conversation',
  src: `/sales-conversation/default/${flowId}`,
  flowType: FlowType.SALES_CONVERSATION,
});

export default flowsConfig;
